module.exports = __webpack_public_path__ + "static/media/partner.1e05a13d.svg";